import React, {PropTypes, Component} from 'react'
import HtmlContent from 'elements/HtmlContent'
import {connect} from 'react-redux'
import {getText} from 'state/ducks/text'

@connect(
	(initState, {id}) => state => {
		const text = state.text[id]
		return {
			content: text && text[state.app.lang],
		}
	},
	{getText}
)
export default class StaticHtml extends Component {
	static propTypes = {
		id: PropTypes.string.isRequired,
		content: PropTypes.string,
		className: PropTypes.string,
		getText: PropTypes.func.isRequired,
	}
	componentDidMount() {
		const {content, id, getText} = this.props
		if (!content) {
			getText(id)
		}
	}
	render() {
		const {content, className} = this.props
		if (!content) {return <p>…</p>}
		return <HtmlContent {...{className, content}}/>
	}
}



// WEBPACK FOOTER //
// ./components/StaticHtml.jsx